export enum ModalTypeEnum {
  AccessibilityStatement = 'accessibilityStatement',
  TermsOfUse = 'termsOfUse',
  PrivacyPolicy = 'privacyPolicy',
}
